
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { Fields } from "../../models/column-settings.model";
import { Location } from "@angular/common";
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { takeUntil, Subject, debounceTime } from "rxjs";
import { ImportserialService } from '../../services/importserial.service';
import { TrackingOptions } from '../../models/trackingOptions.model';
import { AppMainService } from 'src/app/app-main.service';
import { MessageService } from 'primeng/api';
import { SerialType } from '../../enums/serial-details.enum';
import { SerialDetailsBlockComponent } from '../serial-details-block/serial-details-block.component';
import { Router } from '@angular/router';
import { AppMainComponent } from 'src/app/app.main.component';

@Component({
  selector: 'app-serial-details',
  templateUrl: './serial-details.component.html',
  styleUrls: ['./serial-details.component.scss']
})
export class SerialDetailsComponent implements OnInit, OnDestroy {

  data: any[] = [];
  pageSize: number = 15;
  pageNumber: number = 1;
  totalRecord: number = 0;
  pageNumber2: number = 1;
  pageSize2 : number =15;
  first: number = 0;
  rowsPerPage = [15, 30, 50, 100];
  reportTotalRowSum: any = {};
  reportTotalRowAvg: any = {};
  isActivation: boolean = false;
  isResidual: boolean = false;
  aggregateTypes = [
    { type: 'Total', code: 'Sum' },
    { type: 'Avg', code: 'Avg' },
    { type: 'Count', code: 'Count' }
  ];
  selectedData = null;
  isLeftTableHide: boolean = false;
  allCols = [];
  cols = [];
  colDetails = [];
  activeCols = [];
  searchCols = [];
  importCols = [];
  selectedView = "list";
  menuItems;
  selectedGroupByValue: any = null;
  selectedGroupBy: any = null;
  selectedSubGroupBy: any = null;
  selectedSubGroupByValue: any = null;
  selectedAggregateTypeByValue: any = this.aggregateTypes[2];
  selectedAggregateTypeBy: any = this.aggregateTypes[2];
  selectedSummaryField: any = [];
  selectedSummaryFieldValue: any = [];
  enabledListCols: Fields[] = [];
  detailsCols = [];
  isShowSideBtn: boolean = true;
  selectedChannel = "Serial Details";
  /**Filter**/
  filterCols = [];
  summaryCols = [];
  filters = [];
  searchValue: string = '';
  /**import**/
  trackingEnabled: boolean = false;
  trackingOptions: TrackingOptions[] = [];
  disabledSave: boolean = false;
  displayImport: boolean = false;
  serialOnly: boolean = true;
  showWarehouse: boolean = true;
  wareHouseList = [];
  /**Column Setting**/
  showDiv = {
    collists: true,
    details: false
  }
  maxNo = false;
  totalAmt = 0;
  maxNo2 = false;
  totalAmt2 = 0;
  tab = 'tab1';
  settingConfig: any;
  colArray = [];
  colArrayDetails = [];
  maxColCount: number = 0;
  maxDetailColCount: number = 0;
  colSettingsHeader: string = 'Serial Settings';
  displaySettings: boolean = false;
  showFloatHeader: boolean = false;

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  modelChanged = new Subject<string>();
  @ViewChild(SerialDetailsBlockComponent) detailView: SerialDetailsBlockComponent;

  constructor(private _location: Location, private importService: ImportserialService, private appMainService: AppMainService,
    private messageService: MessageService, private router: Router, private app: AppMainComponent
  ) {
    this.modelChanged.pipe(
      debounceTime(700))
      .subscribe(() => {
        this.onGlobalSearch();
      })
  }

  ngOnInit(): void {
    this.loadSerialISettings();
    this.loadColSettings();
    this.menuItems = [
      {
        label: "Refresh",
        icon: "pi pi-refresh ",
        command: () => {
          this.refresh();
        },
      },
      {
        label: "Import",
        icon: "pi pi-upload ",
        command: () => {
          this.openImport();
        },
      },
      {
        label: 'Settings',
        icon: 'pi pi-cog ',
        command: (event) => this.settings()
      }
    ]
  }

  loadSerialISettings() {
    this.importService.getAllInventorySettings().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((iSettings) => {
      this.trackingEnabled = iSettings?.find(set => set.code == 'allowtracking')?.enabled;
      switch (this.router.url) {
        case '/serial-details/activation-detail':
          if (this.getSubMenuPermissions('Activation')) {
            this.selectedChannel = 'Activation Details';
            this.serialOnly = false;
          }
          break;
        case '/serial-details/residual-detail':
          if (this.getSubMenuPermissions('Residual')) {
            this.selectedChannel = 'Residual Details';
            this.serialOnly = false;
          }
          break;
        case '/serial-details/commission-details':
          if (this.getSubMenuPermissions('Commission')) {
            this.selectedChannel = 'Commission Details';
            this.serialOnly = false;
          }
          break;
        case '/serial-details/spiff-details':
          if (this.getSubMenuPermissions('Spiff')) {
            this.selectedChannel = 'Spiff Details';
            this.serialOnly = false;
          }
          break;
        default:
          if (this.trackingEnabled && this.getSubMenuPermissions('SerialDetails')) {
            this.selectedChannel = 'Serial Details';
            this.serialOnly = true;
          } else if (this.getSubMenuPermissions('Activation')) {
            this.selectedChannel = 'Activation Details';
            this.serialOnly = false;
            this._location.go('/serial-details/activation-detail');
          } else if (this.getSubMenuPermissions('Commission')) {
            this.selectedChannel = 'Commission Details';
            this.serialOnly = false;
            this._location.go('/serial-details/commission-detail');
          } else if (this.getSubMenuPermissions('Spiff')) {
            this.selectedChannel = 'Spiff Details';
            this.serialOnly = false;
            this._location.go('/serial-details/spiff-detail');
          } else {
            this.selectedChannel = 'Residual Details';
            this.serialOnly = false;
            this._location.go('/serial-details/residual-detail');
          }
      }
      this.loadTrackingSetting(this.serialTypeId);
      this.getFilterColumns();
    })
  }

  getSubMenuPermissions(menu: string): boolean {
    const userPermissions = JSON.parse(localStorage.getItem('userPermissions'));
    return userPermissions?.some((p) => p.objectName == menu && p.permissions.some(permission => permission.statusId === 1));
  }

  loadColSettings() {
    this.importService.getColSettings().subscribe(config => {
      this.settingConfig = config;
      if (this.settingConfig?.configurationDetails?.length > 0) {
        this.allCols = JSON.parse(config.configurationDetails[0].configJSONValue);
        this.cols = this.allCols?.filter(col => col.typeId == this.serialTypeId).map(column => column.ListCols)[0];
        this.colDetails = this.allCols?.filter(col => col.typeId == this.serialTypeId).map(column => column.ListDetailCols)[0];
        this.activeCols = this.cols.filter(e => e.checked && e.show);
        this.loadList(this.serialTypeId);
      }
    })
  }

  onClick(check) {
    if (check == 1) {
      this.tab = "tab1";
    } else if (check == 2) {
      this.tab = "tab2";
    }
  }

  onChange(isChecked: boolean) {
    if (isChecked) {
      this.totalAmt++;
    } else {
      this.totalAmt--;
    }
    this.maxNo = this.totalAmt === 12;
  }

  settings() {
    this.totalAmt = 0;
    this.colArray = _.cloneDeep(this.cols);
    this.colArrayDetails = _.cloneDeep(this.colDetails);
    this.maxColCount = this.colArray?.filter(col => col.show)?.length;
    this.maxDetailColCount = this.colArrayDetails?.filter(col => col.show)?.length;
    for (let col of this.colArrayDetails) {
      if (col.checked) { this.totalAmt++; }
    }
    this.maxNo = this.totalAmt === 12;
    this.displaySettings = true;
  }

  saveSettings() {
    for (let col of this.colArray) {
      col.value = '';
      if (col.checked) {
        col.show = true;
      }
    }
    for (let col of this.colArrayDetails) {
      col.value = '';
      if (col.checked) {
        col.show = true;
      }
    }
    const columnData = this.allCols.find(sc => sc.typeId == this.serialTypeId);
    if (columnData) {
      columnData.DefaultView = "list";
      columnData.ListCols = this.colArray;
      columnData.ListDetailCols = this.colArrayDetails;
      const index = this.allCols.indexOf(columnData)
      this.allCols[index] = columnData;
    }
    const data = {
      id: (this.settingConfig ? this.settingConfig.id : 0),
      createdSource: this.settingConfig.createdSource,
      updatedSource: this.app.userIP,
      createdBy: this.settingConfig.createdBy,
      updatedBy: this.app.user.userId,
      createdDate: new Date().toISOString(),
      updatedDate: new Date().toISOString(),
      organizationId: this.settingConfig.organizationId,
      name: this.settingConfig.name,
      description: this.settingConfig.description,
      configJSONSchema: "",
      configJSONValue: JSON.stringify(this.allCols),
      objectId: this.settingConfig.objectId,
      levelId: 4, // user level permission
      levelRecordId: this.app.user.userId, // user permissions, here we pass user id
      categoryId: this.settingConfig.categoryId,
      statusId: 1,
      typeId: this.settingConfig.typeId
    }
    this.importService.updateColSettings(data).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          this.appMainService.isHideSpinner("colsettings");
          this.displaySettings = false;
          this.cols = _.cloneDeep(this.colArray);
          this.colDetails = _.cloneDeep(this.colArrayDetails);
          this.getDetailsColName(this.colDetails);
          this.getFilterColumns();
          this.messageService.add({ severity: "success", summary: "Success", detail: "Settings updated successfully..." });
        },
        error: (error) => {
          this.appMainService.isHideSpinner("colsettings");
          this.displayImport = false;
          this.messageService.add({ severity: "error", summary: "Error", detail: `${error.error?.Message}` });
        },
        complete() {
        },
      });

  }

  dropCol(event: CdkDragDrop<string[]>) {
    if (event.currentIndex > 0)
      moveItemInArray(this.colArray, event.previousIndex, event.currentIndex);
  }

  get serialTypeId() {
    return (this.selectedChannel == 'Serial Details') ? SerialType.Serial : (this.selectedChannel == 'Activation Details') ? SerialType.Activation :
    (this.selectedChannel == 'Commission Details') ? SerialType.Commission : (this.selectedChannel == 'Spiff Details') ? SerialType.Spiff : SerialType.Residual;
  }

  loadTrackingSetting(serialType) {
    this.importService.getOrganizationTrackingDefaultSettings(serialType).subscribe(res => {
      this.trackingOptions = [...res];
    })
  }

  onRowSelect(e) {
    this.isShowSideBtn = false;
    this.isLeftTableHide = true;
    this.selectedView = "split";
    this.getDetailsColName(this.colDetails);
  }

  getDetailsColName(colSetings: any[]): void {        
    this.detailsCols = [];
    for (let col of colSetings) {
      if (col.show && col.checked) {
        this.detailsCols.push({ labelname: col.header, field: (col.field == 'itemNo' ? 'productName' : col.field), checked: col.show, dataType: col.dataType, symbol: col.symbol, decimal: col.noOfDecimal });
      }
    }
  }

  backListView() {
    this.isShowSideBtn = true;
    this.isLeftTableHide = false;
    this.selectedView = "list";
    this.selectedData = null;
  }

  refresh() {
    if (this.selectedView == 'list') {
      this.loadTrackingSetting(this.serialTypeId);
      this.loadColSettings();
    } else {
      this.getDetailsColName(this.colDetails);
      this.detailView.refreshData();
    }
  }

  showGroupBy() {
    if (this.selectedChannel == 'Serial Details') {
      const grpByField = ['itemNo', 'warehouseName'];
      this.enabledListCols = this.cols?.filter(col => grpByField.includes(col.field));
    } else {
      this.enabledListCols = this.cols?.filter(col => col.checked && col.show);
    }
    this.selectedGroupBy = this.selectedGroupByValue || null;
    this.selectedSubGroupBy = this.selectedSubGroupByValue || null;
    this.selectedSummaryField = this.selectedSummaryFieldValue?.length ? this.selectedSummaryFieldValue : this.summaryCols;
    this.selectedAggregateTypeBy = this.selectedAggregateTypeByValue ||  null;
  }

  applyGroup() {
    //apply group filter
    this.selectedGroupByValue = this.selectedGroupBy;
    this.selectedSubGroupByValue = this.selectedSubGroupBy;
    this.selectedSummaryFieldValue = this.selectedSummaryField;
    this.selectedAggregateTypeByValue = this.selectedAggregateTypeBy;
    this.pageNumber = 1;
    this.pageSize = 15;
    this.first = 0;
    this.searchCols = this.cols?.map(col => ({
      columnName: col.field,
      isCustom: false
    }));
    this.loadList(this.serialTypeId);
  }

  resetGroup() {
    //reset filter
    this.selectedGroupBy = null;
    this.selectedGroupByValue = null;
    this.selectedSubGroupBy = null;
    this.selectedSubGroupByValue = null;
    this.selectedSummaryField = [];
    this.selectedSummaryFieldValue = [];
    this.selectedAggregateTypeBy =  this.aggregateTypes[2];
    this.selectedAggregateTypeByValue =  this.aggregateTypes[2];
    this.loadList(this.serialTypeId);
  }

  filterSelectedChannel(str, url) {
    this.selectedChannel = str;
    this.selectedView = 'list';
    this.selectedGroupByValue = null;
    this.selectedGroupBy = null;
    this.selectedSubGroupBy = null;
    this.selectedSubGroupByValue = null;
    this.selectedSummaryField = [];
    this.selectedSummaryFieldValue = [];
    this.selectedAggregateTypeBy =  this.aggregateTypes[2];
    this.selectedAggregateTypeByValue =  this.aggregateTypes[2];
    this.searchValue = '';
    this.searchCols = [];
    this.filters = [];
    switch (this.selectedChannel) {
      case 'Residual Details':
        this.serialOnly = false;
        this.showWarehouse = false;
        this.loadTrackingSetting(SerialType.Residual);
        this.loadColSettings();
        break;
      case 'Activation Details':
        this.serialOnly = false;
        this.showWarehouse = false;
        this.loadTrackingSetting(SerialType.Activation);
        this.loadColSettings();
        break;
      case 'Commission Details':
        this.serialOnly = false;
        this.showWarehouse = false;
        this.loadTrackingSetting(SerialType.Commission);
        this.loadColSettings();
        break;
      case 'Spiff Details':
        this.serialOnly = false;
        this.showWarehouse = false;
        this.loadTrackingSetting(SerialType.Spiff);
        this.loadColSettings();
        break;
      default:
        this.serialOnly = true;
        this.showWarehouse = true;
        this.loadTrackingSetting(SerialType.Serial);
        this.loadColSettings();
        break;
    }
    this.getFilterColumns();
    this._location.go(url);
  }

  getChildData(event, rowData, childData?) {
    this.pageNumber2 = event.first / event.rows + 1;
    this.pageSize2 = event.rows;
    this.loadSerialDetailsSubGroup(this.pageNumber2, this.pageSize2, this.serialTypeId, this.filters, this.searchValue, this.searchCols, this.selectedGroupByValue?.field, rowData, this.selectedSubGroupByValue?.field, childData,this.selectedSummaryField?.length > 0 ? this.selectedSummaryField : this.summaryCols);
  }

  getData(event) {
    this.pageNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.first = event.first;
    this.loadList(this.serialTypeId);
  }

  loadList(typeId: number) {
    this.data = [];
    if (this.selectedGroupBy || this.selectedSummaryField?.length>0) {
      this.loadSerialDetailsByGroupBy(this.pageNumber, this.pageSize, typeId, this.filters, this.searchValue, this.searchCols, this.selectedGroupBy?.field, this.selectedSubGroupBy?.field, this.selectedSummaryField?.length > 0 ? this.selectedSummaryField :  this.summaryCols)
    } else {
      this.loadSerialDetails(this.pageNumber, this.pageSize, typeId, this.filters, this.searchValue, this.searchCols);
    }
  }

  loadSerialDetails(pageNumber: number, pageSize: number, typeId: number, filters: any[], searchValue: string, searchCols: any[]) {
    this.appMainService.isShowSpinner("loadData");
    this.importService.getSerialDetailsData(pageNumber, pageSize, typeId, filters, searchValue, searchCols).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          let { serialDetails, headers } = res;
          serialDetails = serialDetails ?? [];
          headers = headers ?? [];
          this.data = serialDetails;
          this.totalRecord = headers["TotalCount"];
          this.selectedView = 'list';
          this.showFloatHeader = true;
          this.appMainService.isHideSpinner("loadData");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

  onTabChange(event) {
    if (event.index === 1) {
      this.isActivation = true;
    } else if (event.index === 2) {
      this.isResidual = true;
    } else {
      this.isActivation = false;
      this.isResidual = false;
    }
  }

  loadSerialDetailsByGroupBy(pageNumber: number, pageSize: number, typeId: number, filters: any[], searchValue: string, searchCols: any[], groupCol: string, subGroupCol: string, summaryCols: any[]) {
    this.appMainService.isShowSpinner("loadData");
    this.importService.getSerialDetailsDataByGroup(pageNumber, pageSize, typeId, filters, searchValue, searchCols, groupCol, subGroupCol, summaryCols).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          let { serialDetails, headers } = res;
          serialDetails = serialDetails ?? [];
          headers = headers ?? [];
          this.data = serialDetails.groupedList ?? [];
          this.reportTotalRowSum = serialDetails.grandSumMap;
          this.reportTotalRowAvg = serialDetails.grandAvgMap;
          this.totalRecord = headers["TotalCount"];
          this.selectedView = 'list';
          this.appMainService.isHideSpinner("loadData");
          this.showFloatHeader = true;
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

  loadSerialDetailsSubGroup(pageNumber: number, pageSize: number, typeId: number, filters: any[], searchValue: string, searchCols: any[], groupBy: string, rowData, subGroupBy, childData,summaryCols:any[]) {
    this.appMainService.isShowSpinner("loadData");
    this.importService.getSubGroupSerialDetailsData(pageNumber, pageSize, typeId, filters, searchValue, searchCols, groupBy, rowData.groupByValue, subGroupBy, childData?.groupByValue,summaryCols).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          if (childData) {
            childData.list = res.list;
            childData.numericSumMap = res.numericSumMap;
            childData.numericAvgMap = res.numericAvgMap;
          } else {
            rowData.list = res.list;
            rowData.numericSumMap = res.numericSumMap;
            rowData.numericAvgMap = res.numericAvgMap;
          }
          this.selectedView = 'list';
          this.appMainService.isHideSpinner("loadData");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

  /**Import data from excel file**/
  openImport() {
    if (this.selectedChannel == 'Serial Details') {
      this.appMainService.isShowSpinner("location");
      this.importService.getAllLocations(false).subscribe((wHouse) => {
        this.wareHouseList = wHouse;
        const enabledCols = this.cols.filter(col => col.show);
        this.importCols = [...enabledCols];
        this.appMainService.isHideSpinner("location");
        this.displayImport = true;
      });
    } else {
      const enabledCols = this.cols.filter(col => col.show && col.order);
      this.importCols = [...enabledCols];
      this.displayImport = true;
    }
  }

  hideImport() {
    this.displayImport = false;
  }

  prepareSerialImportData(data) {
    const reqBody = (data.excelData || []).map((sr) => {
      return {
        itemNo: sr.itemNo,
        serialNo: sr.serialNo,
        lotNo: sr.lotNo,
        revisionNo: sr.revisionNo,
        expiration: sr.expiration,
        serialNo2: sr.serialNo2,
        serialNo3: sr.serialNo3,
        serialNo4: sr.serialNo4,
        serialNo5: sr.serialNo5,
        serialNo6: sr.serialNo6,
        serialNo7: sr.serialNo7,
        serialNo8: sr.serialNo8,
        serialNo9: sr.serialNo9,
        serialNo10: sr.serialNo10,
        serialNo11: sr.serialNo11,
        serialNo12: sr.serialNo12,
        serialNo13: sr.serialNo13,
        serialNo14: sr.serialNo14,
        serialNo15: sr.serialNo15,
        serialNo16: sr.serialNo16,
        serialNo17: sr.serialNo17
      };
    });
    return reqBody;
  }

  prepareActivationImportData(data) {
    const reqBody = (data.excelData || []).map((sr) => {
      return {
        field1: sr.field1,
        field2: sr.field2,
        field3: sr.field3,
        field4: sr.field4,
        field5: sr.field5,
        field6: sr.field6,
        field7: sr.field7,
        field8: sr.field8,
        field9: sr.field9,
        field10: sr.field10,
        field11: sr.field11,
        field12: sr.field12,
        field13: sr.field13,
        field14: sr.field14,
        field15: sr.field15,
        field16: sr.field16,
        field17: sr.field17,
        field18: sr.field18,
        field19: sr.field19,
        field20: sr.field20
      };
    });
    return reqBody;
  }

  createUpdateFolderFiles(data) {
    const files = [];
    files.push(data.files)
    const formData = this.setFormData(files);
    if (this.selectedChannel == 'Serial Details') {
      formData.append("ModuleNameWithDisplayOrder", "Serial-1");
    } else if (this.selectedChannel == 'Activation Details') {
      formData.append("ModuleNameWithDisplayOrder", "Activation-1");
    } else if (this.selectedChannel == 'Commission Details') {
      formData.append("ModuleNameWithDisplayOrder", "Commission-1");
    } else if (this.selectedChannel == 'Spiff Details') {
      formData.append("ModuleNameWithDisplayOrder", "Spiff-1");
    } else {
      formData.append("ModuleNameWithDisplayOrder", "Residual-1");
    }
    this.importService.uploadFilesByOrganization(formData).subscribe({
      next: (res) => {
        data.attachmentId = res[0]?.attachmentId;
        if (this.selectedChannel == 'Serial Details') {
          this.importSerialDetails(data);
        } else if (this.selectedChannel == 'Activation Details') {
          this.importActivationDetails(data, 'activation');
        } else if (this.selectedChannel == 'Commission Details') {
          this.importActivationDetails(data, 'commission');
        } else if (this.selectedChannel == 'Spiff Details') {
          this.importActivationDetails(data, 'spiff');
        } else {
          this.importActivationDetails(data, 'residual');
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: "Error occurred ...",
        });
      },
    });
  }

  setFormData(files): any {
    const formData = new FormData();
    for (let file of files) {
      formData.append("Files", file);
    }
    return formData;
  }

  saveImport(data) {
    this.createUpdateFolderFiles(data);
  }

  importSerialDetails(data) {
    this.appMainService.isShowSpinner('bulkimport');
    const reqData = this.prepareSerialImportData(data);
    this.importService.bulkImportSerials(data.selectedLocation?.id,data.attachmentId,reqData).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          this.appMainService.isHideSpinner("bulkimport");
          this.disabledSave= false;
          this.displayImport = false;
          this.loadList(this.serialTypeId);
          this.messageService.add({ severity: "success", summary: "Success", detail: "Data imported successfully..." });
        },
        error: (error) => {
          this.appMainService.isHideSpinner("bulkimport");
          this.displayImport = false;
          this.messageService.add({ severity: "error", summary: "Error", detail: `${error.error.Message}` });
        },
        complete() {
        },
      });
  }

  importActivationDetails(data, type) {
    this.appMainService.isShowSpinner('bulkimport');
    const reqData = this.prepareActivationImportData(data);
    this.importService.bulkImportActivations(data.month, data.year, data.batchId,data.attachmentId, reqData, type).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          this.appMainService.isHideSpinner("bulkimport");
          this.disabledSave= false;
          this.displayImport = false;
          this.loadList(this.serialTypeId);
          this.messageService.add({ severity: "success", summary: "Success", detail: "Data imported successfully..." });
        },
        error: (error) => {
          this.appMainService.isHideSpinner("bulkimport");
          this.displayImport = false;
          this.messageService.add({ severity: "error", summary: "Error", detail: `${error.error.Message}` });
        },
        complete() {
        },
      });
  }

  /**Column Filters**/
  getFilterColumns() {
    this.appMainService.isShowSpinner("loadData");
    this.importService.getFilterData(this.serialTypeId).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          this.filterCols = res.map(obj => ({
            ...obj, // Spread the existing properties
            typeId: this.serialTypeId // Add the new field
          }));
          const numericFormControl = ['Number', 'Currency', 'Percentage', 'Decimal'];
          this.summaryCols = res.filter(fld => numericFormControl.includes(fld.summaryFormControlType) && fld.code!=='year');
          this.appMainService.isHideSpinner("loadData");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

  applyFilters(data) {
    this.filters = data.selectedFilter ?? [];
    this.pageNumber = 1;
    this.pageSize = 15;
    this.first = 0;
    this.loadList(this.serialTypeId);
  }

  onGlobalSearch() {
    this.pageNumber = 1;
    this.pageSize = 15;
    this.first = 0;
    this.isLeftTableHide = false;
    this.searchCols = this.cols?.map(col => ({
      columnName: col.field,
      isCustom: false
    }));
    this.loadList(this.serialTypeId);
  }

  changed(event) {
    this.modelChanged.next("");
  }

  hideSideMenu(){
    this.showFloatHeader = false;
    this.isShowSideBtn = false;
    setTimeout(()=>{
      this.showFloatHeader = true;
    }, 100);
  }

  showSideMenu(){
    this.showFloatHeader = false;
    this.isShowSideBtn = true;
    setTimeout(()=>{
      this.showFloatHeader = true;
    }, 100);
  }

  onRevertSuccess(){
    this.displayImport = false;
    this.loadList(this.serialTypeId);
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }


}